module.exports = __webpack_public_path__ + "static/media/client-side-deployment.eb43290c.jpg";